import { useTranslation } from "react-i18next";
import { SUPPORT_STATUS_META } from "../../utils/constants/support";

export default function TicketStatusBadge({ status, className = "" }) {
  const { t } = useTranslation();
  const meta = SUPPORT_STATUS_META[status];
  if (!meta) return null;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-[11px] font-bold whitespace-nowrap ${meta.badge} ${className}`}
    >
      {t(meta.labelKey)}
    </span>
  );
}
